// extracted by mini-css-extract-plugin
module.exports = {"spec":"PartnerListItem_spec__QVicY","link":"PartnerListItem_link__orAJc"};